/* eslint-disable react-hooks/exhaustive-deps */
import "../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as HERBUI from "react-bootstrap";
import "../loginandlandingpage.css";
import { FiPower } from "react-icons/fi";
import { BiLock } from "react-icons/bi";
import DashboardCardBudget from "../components/DashboardCardBudget";
import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { CommonAjaxGetRequestWithOutParams } from "../Api/CommonAjaxUtils";
import { SERVICES_URL, LOGIN_PAGE_URL, CHANGE_PASSWORD_UI_URL, AWS_DOWNLOAD_URL, chatwidgeturl, BASE_URL } from "../Api/APIURLS";
import { useDispatch } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Swal from "sweetalert2";
import { ClearLocalStorage } from "../components/Functions";
import { FaArrowRight } from "react-icons/fa";
import BudgetDataEntryAlert from "../components/BudgetDataEntryAlert";
import AIMSPendingPopup from "../components/AIMSPendingPopup";
import ApgliPendingPopUp from "../components/ApgliPendingPopUp";
import ESSChatWidget from "./ESSChatWidget";
import PensionInstructionPage from "./PensionInstructionPage ";
var createGuest = require('cross-domain-storage/guest');
function Dashboard() {
  const [showPopup, setShowPopup] = useState(false);
  const [isDdo, setisDdo] = useState()
  const [showAimPopup, setShowAimPopup] = useState(false);
  const [showapglipopup, setShowapgliPopup] = useState(false)
  const [showChatWidget, setShowChatWidget] = useState(false);
  const [showIntPopup, setShowIntPopup] = useState(false)
  const [list, setList] = useState([])


  let parentIdsList = [];
  const [tabs, setTabs] = useState()
  const dispatch = useDispatch();
  const history = useHistory();
  const [context, setContext] = useState(false);
  const [servicesExists, setServicesExists] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0)
  const [finalTabs, setFinalTabs] = useState([])
  const displayName = localStorage.getItem('displayName');

  let getErrMsg = JSON.parse(localStorage.getItem('expirationErrorMsg'))
  const handleClose = () => {
    setShowPopup(false)
  }

  useEffect(() => {
    setShowPopup(true);
  }, []);

  useEffect(() => {
    if (localStorage.getItem('token') !== null) {
      const token = localStorage.getItem('token');
      if (localStorage.getItem('serviceList') === null) {
        CommonAjaxGetRequestWithOutParams(SERVICES_URL, dispatch).then((response) => {

          setisDdo(response.isDdo);
          setContext(false);

          if (response && Object.keys(response).length > 0) {

            setContext(true);

            localStorage.setItem("serviceList", JSON.stringify(response));
            localStorage.setItem("loginname", response?.name);
            localStorage.setItem("loginsurname", response?.surname);

            setTabs(response);
            setServicesExists(true);

            // ✅ CALL CHAT API AFTER MAIN API
            getChatWidgetEnable();

          } else {
            setContext(true);
            setServicesExists(false);
            dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
          }
        });
      } else {

        setContext(true);
        setServicesExists(true);

        let servicesList = JSON.parse(localStorage.getItem('serviceList'));
        setTabs(servicesList);
        // ⚠️ optional: still call chat API here if needed
        getChatWidgetEnable();
      }

    } else {
      Swal.fire({
        text: 'Session Expired!',
        icon: 'error',
        confirmButtonColor: '#3085d6',
        confirmButtonText: "Ok"
      }).then(function (isConfirm) {
        if (isConfirm.value) {
          ClearLocalStorage();
          window.location.href = LOGIN_PAGE_URL;
        }
      });
    }
  }, []);

  // useEffect(() => {
  //   if (localStorage.getItem('token') !== null) {
  //     if (localStorage.getItem('serviceList') === null) {
  //       let token=localStorage.getItem('token');
  //       CommonAjaxGetRequestWithOutParams(SERVICES_URL, dispatch).then((response) => {

  //         setisDdo(response.isDdo)
  //         setContext(false);
  //         if (response !== '' && response !== null && response !== undefined && Object.keys(response).length > 0) {
  //           setContext(true);
  //           localStorage.setItem("serviceList", JSON.stringify(response));
  //           localStorage.setItem("loginname", response?.name)
  //           localStorage.setItem("loginsurname", response?.surname)
  //           setTabs(response)
  //           setServicesExists(true)
  //           getChatWidgetEnable(token)

  //         }
  //         else {
  //           setContext(true);
  //           setServicesExists(false)
  //           dispatch({ type: 'HIDE_SPINNER', payload: { key: 'showSpinner', value: false } });
  //         }
  //       });
  //     }
  //     else {
  //       setContext(true);
  //       setServicesExists(true)
  //       let servicesList = JSON.parse(localStorage.getItem('serviceList'));
  //       setTabs(servicesList)
  //     }
  //   }
  //   else {
  //     Swal.fire({
  //       text: 'Session Expired!',
  //       icon: 'error',
  //       confirmButtonColor: '#3085d6', confirmButtonText: "Ok"
  //     }).then(function (isConfirm) {
  //       if (isConfirm.value) {
  //         ClearLocalStorage()
  //         window.location.href = LOGIN_PAGE_URL
  //       }
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])
  useEffect(() => {
    let tabIndex = JSON.parse(localStorage.getItem("tabIndex"))
    if (tabIndex !== null && tabIndex !== undefined && tabIndex !== "") {
      setSelectedIndex(tabIndex)
    }
    else {
      localStorage.setItem("tabIndex", JSON.stringify(selectedIndex))
    }

  }, [])
  function handleLogOut() {
    history.push("/logOut")

  }

  function ChangePassword() {
    window.location.href = CHANGE_PASSWORD_UI_URL
  }
  function onTabChange(tabIndex) {
    localStorage.setItem("tabIndex", JSON.stringify(tabIndex))
    setSelectedIndex(tabIndex)
  }

  const userName = localStorage.getItem('userName');

  const getLoginName = localStorage.getItem("loginname");
  const getLoginSurName = localStorage.getItem("loginsurname");
  // Normalize to empty string if null/undefined
  const loginName = getLoginName?.trim() || "";
  const loginSurName = getLoginSurName?.trim() || "";
  // Check for valid userName
  const parsedUserName = (userName && userName !== "undefined") ? JSON.parse(userName) : "";

  const isEmpty = (v) => !v || v.trim() === "";

  function popupfunct(type) {
    if(type=="P")
    {
       CommonAjaxGetRequestWithOutParams(BASE_URL+'ppmis/ddo/srPostalEntryPending',dispatch).then((res)=>{
            if(res?.SCODE=="01")
            {
               
                setList(res?.SBODY)
                if(res?.SBODY.length>0)
                {
                  setShowIntPopup(true)
                }
                else{
                  setShowIntPopup(false)
                }
            }
            else{
                setList([])
                 setShowIntPopup(false)
            }
         })
    

    }
 
  }
  const handleCloseAIMPopup = (type) => {
    if (type === "aim") {
      setShowAimPopup(false)
    }
    if (type === "A") {
      setShowapgliPopup(false)
    }
  }
  const fetchTabsWithImages = async (updatedTabs) => {
    if (!Array.isArray(updatedTabs) || updatedTabs.length === 0) {
      return;
    }

    const promises = updatedTabs.map(async (tab) => {
      const res = await fetch(
        AWS_DOWNLOAD_URL + tab.imageUrl
      );
      const raw = await res.text();
      return { ...tab, imagePublicUrl: raw };
    });

    const result = await Promise.all(promises);
    setFinalTabs(result);
  };


  useEffect(() => {
    const updatedTabs = tabs?.tabHeader?.tabheaderDetails
      ?.filter(t => t.tileDisplay === true);
    if (!updatedTabs || updatedTabs.length === 0) return;
    fetchTabsWithImages(updatedTabs);
  }, [tabs]);

  function getChatWidgetEnable() {
    CommonAjaxGetRequestWithOutParams(chatwidgeturl, dispatch)
      .then((response) => {


        const isEnabled = response?.AIAssistance === true;

        setShowChatWidget(isEnabled);

       

      })
      .catch((err) => {
        console.error("Chat widget API error:", err);
        setShowChatWidget(false);
      });
  }
    const closeInstruction=()=>{
    setShowIntPopup(false)
  }
  return (
    <div className="Dashboard" style={{ display: context ? "block" : "none" }}>
      <HERBUI.Container fluid>
        <HERBUI.Row>
          <HERBUI.Navbar collapseOnSelect expand="lg" fixed="top" className="HERB-Top-Nav" style={{ posistion: "fixed", top: "0px" }} >
            <HERBUI.Navbar.Brand href="#home">
              <img
                src="img/herb.svg"
                width="250"
                height="45"
                className="d-inline-block align-top"
                alt="NIDHI"
              />
            </HERBUI.Navbar.Brand>
            <HERBUI.Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <HERBUI.Navbar.Collapse id="responsive-navbar-nav">
              <HERBUI.Nav className="me-auto"></HERBUI.Nav>
              <HERBUI.Nav>
                <HERBUI.NavDropdown
                  className="header-dropdown-setting"
                  title={
                    (isEmpty(loginName) && isEmpty(loginSurName) && !isEmpty(displayName) && !isEmpty(parsedUserName))
                      ? (
                        <b>
                          <span>Welcome:</span>&nbsp;
                          {displayName} ({parsedUserName})
                        </b>
                      )
                      : (
                        <b>
                          <span>Welcome:</span>&nbsp;
                          {(loginName || "").trim()} {(loginSurName || "").trim()} ({parsedUserName || ""})
                        </b>
                      )
                  }
                  id="basic-nav-dropdown"
                >

                  <HERBUI.NavDropdown.Item onClick={ChangePassword}>
                    <BiLock size={25} onClick={ChangePassword} /> Change Password
                  </HERBUI.NavDropdown.Item>
                  <HERBUI.NavDropdown.Item onClick={() => handleLogOut()}>
                    <FiPower size={23} onClick={() => handleLogOut()} /> Sign Out
                  </HERBUI.NavDropdown.Item>
                </HERBUI.NavDropdown>
              </HERBUI.Nav>
            </HERBUI.Navbar.Collapse>
          </HERBUI.Navbar>
        </HERBUI.Row>
      </HERBUI.Container>
      <div className="main_section">
      </div>
      <HERBUI.Container style={{ marginTop: "80px" }}>
        <HERBUI.Row>
          <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="page-titlespacing">
            <div className="d-flex justify-content-between">
              <div className="inner-herbpage-service-title1 ">
                <h1>Dashboard</h1>
              </div>
              <div className="mt-4 pt-2 ps-4">
                <span style={{ color: 'red', fontSize: '17px' }}>{getErrMsg}</span>
                &nbsp;
                {
                  (getErrMsg !== null && getErrMsg !== undefined && getErrMsg !== '' && getErrMsg !== 'undefined' && getErrMsg !== 'null') &&
                  <button className="btn btn-primary btn-sm"
                    onClick={() => window.location.href = CHANGE_PASSWORD_UI_URL}
                  > <FaArrowRight />  Click here</button>
                }
              </div>
            </div>
          </HERBUI.Col>
        </HERBUI.Row>
      </HERBUI.Container>
      {servicesExists === false &&
        <HERBUI.Container>
          <HERBUI.Row>
            <HERBUI.Col xs={12} sm={12} md={12} lg={10} xl={12} xxl={12}>
              <div className='alert alert-info'>
                <span className='mb-1'>Services are not assigned to you. Please contact Helpdesk.</span>
              </div>
            </HERBUI.Col>
          </HERBUI.Row>
        </HERBUI.Container>
      }
      {servicesExists &&
        <HERBUI.Container>
          <Tabs selectedIndex={selectedIndex} onSelect={(tabIndex) => onTabChange(tabIndex)}>
            <TabList>
              {finalTabs?.map(tab => (
                <Tab onClick={() => popupfunct(tab.moduleType)}>
                  <img
                    src={tab.imagePublicUrl}
                    className="tabiconc"
                    alt="MasterData"
                  />
                  <p className="tab-cap" moduleType={tab.moduleType}>
                    {tab.tileTitle}
                  </p>
                </Tab>
              ))}
            </TabList>
            {tabs !== undefined && Object.entries(tabs?.tabData).map(([key, val]) => {
              return (
                <TabPanel>
                  <HERBUI.Container>
                    <HERBUI.Row>
                      <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                        {val !== undefined && val !== "" && val.parentServices.length > 0 &&
                          val.parentServices.filter((service) => {
                            parentIdsList?.push(service.serviceId);
                            return service.childServices.length !== 0
                          }).map((item) => (
                            <>
                              <HERBUI.Row style={{ paddingBottom: "20px" }}>
                                <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                  <div className="inner-herbpage-service-title2">
                                    <h1>{item.serviceName} </h1>
                                  </div>
                                </HERBUI.Col>
                                {(item.childServices.length !== 0) ?
                                  item.childServices.map((child) => {
                                    parentIdsList.push(child.serviceId);
                                    return <DashboardCardBudget className="mb-3 ellips bg-custgreen "
                                      title={child.serviceName} url={child.targetUrl}
                                      index={child.serviceId} module={key}
                                      serviceId={child.serviceId} />
                                  }) : ''
                                }
                              </HERBUI.Row>
                            </>
                          ))}
                      </HERBUI.Col>
                    </HERBUI.Row>
                    <HERBUI.Row style={{ paddingBottom: "50px" }}>
                      <HERBUI.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                        <div className="inner-herbpage-service-title2">
                          <h1>Others</h1>
                        </div>
                      </HERBUI.Col>
                      {val !== undefined && val.otherServices
                        !== undefined && val.otherServices !== ''
                        &&
                        val.otherServices.map((item) => (
                          <>
                            <DashboardCardBudget
                              title={item.serviceName} index={item.serviceId}
                              url={item.targetUrl} module={key}
                              serviceId={item.serviceId} />
                          </>
                        ))}
                    </HERBUI.Row>
                  </HERBUI.Container>
                </TabPanel>
              )
            })
            }

          </Tabs>
          <AIMSPendingPopup showpopup={showAimPopup} handleClose={() => handleCloseAIMPopup("aim")} />
          <ApgliPendingPopUp showpopup={showapglipopup} handleClose={() => handleCloseAIMPopup("A")} />
        </HERBUI.Container>
      }

      {showPopup && (isDdo === "1" || isDdo === 1) &&
        <BudgetDataEntryAlert closeModal={handleClose} show={showPopup} isDdo={isDdo} />}

      {
        showIntPopup && <>
          <PensionInstructionPage list={list} show={showIntPopup} closeModel={closeInstruction} />
        </>
      }

      <ESSChatWidget enabled={showChatWidget} />

    </div >


  );
}
export default Dashboard;
